<template>
  <div>
    <v-menu ref="timeMenu" :offset-overflow="true" :allow-overflow="true" :close-on-content-click="false" v-model="openCalendar" transition="slide-x-transition" offset-y max-width="290px" min-width="290px" v-if="!calReadonly">
      <template v-slot:activator="{ on }">
      <v-text-field v-time-mask v-on="on" v-model="textValue" :hint="hint" persistent-hint :label="label" :error-messages="errorMessages" :readonly="readonly" :disabled="disabled" :class="clazz" @blur="textChange()" @input="formatKeyPress()"></v-text-field>
      </template>
      <v-time-picker format="24hr" v-model="calValue" @change="$refs.timeMenu.save(calValue)" @input="calChange()"></v-time-picker>
    </v-menu>
    <v-text-field v-model="textValue" :hint="hint" persistent-hint :label="label" :error-messages="errorMessages" :readonly="readonly" :disabled="disabled" :class="clazz" v-else></v-text-field>
  </div>
</template>

<script>

export default {
  data() {
    return {
      openCalendar: false,
      textValue: undefined,
      calValue: undefined
    }
  },
  computed: {
    calReadonly() {
      // Note vuetify timepick dont support readonly or disabled
      if (this.readonly || this.disabled) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    'value': function (value) {
      this.doInit(value)
    }
  },
  methods: {
    doInit(timeVal) {
      // Format the value here
      this.textValue = timeVal
      this.calValue = timeVal
    },
    textChange() {
      if (this.textValue && this.textValue.length === 5) {
        this.$emit('input', this.textValue)
        this.$emit('blur', this.textValue)
      } else {
        this.textValue = null
        this.$emit('input', this.textValue)
        this.$emit('blur', this.textValue)
      }
    },
    calChange() {
      this.$emit('input', this.calValue)
      this.$emit('blur', this.calValue)
    },
    formatKeyPress() {
      // As cleave has not supported time formatting, we shall do some manual work here
      if (this.textValue) {
        if (this.textValue.length === 2) {
          if (this.textValue >= 24) {
            this.textValue = 23
          }
        } else if (this.textValue.length === 4) {
          const beforeChar = this.textValue.substring(0, 3)
          const firstMinChar = this.textValue.substring(3, 4)
          if (firstMinChar > 5) {
            this.textValue = beforeChar + '5'
          }
        }
      }
    }
  },
  mounted() {
    this.doInit(this.value)
  },
  props: {
    value: {
      type: String,
      default: undefined
    },
    label: {
      type: String,
      default: 'Date'
    },
    hint: {
      type: String,
      default: 'HH:MM (24 Hour)'
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    errorMessages: {
      type: [String, Array],
      default: () => []
    },
    clazz: {
      type: String,
      default: undefined
    }
  }
}
</script>

<style>

</style>
